import { PlatformLocation } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { CustomValidators } from 'src/validators';

@Component({
  selector: 'app-step-company-contact',
  templateUrl: './step-company-contact.component.html',
  styleUrls: ['./step-company-contact.component.scss']
})
export class StepCompanyContactComponent implements OnInit {

  form: FormGroup;
  @Output() submited: EventEmitter<boolean>;
  @Output() formObserver: Subject<FormGroup>;
  @Input() initData: EventEmitter<any>;
  mauticFormSrc: any = null;
  showPassword: boolean = false;
  submiting: boolean = false;

  constructor(
    fb: FormBuilder,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
  ) {

    this.form = fb.group({
      fullname: [ null, Validators.required ],
      lastname: [ null, Validators.required ],
      email: [ localStorage.getItem('email') ],
      gender: [null, Validators.required ],
      phone: [ null,  [ Validators.required, CustomValidators.phone ]],
      // taxDocumentNumber: [ null, [ Validators.required, CustomValidators.cpf ] ],
      taxDocumentNumber: [ null ],
      password: [ null, Validators.required ],
      password2: [ null, [ Validators.required, CustomValidators.match('password')] ]
    })
    this.submited = new EventEmitter<any>();
    this.formObserver = new Subject<FormGroup>();

  }

  ngOnInit(): void {

    this.formObserver.next(this.form);

    if (this.initData)
      this.initData.subscribe((data) => {
        this.form.patchValue({
          fullname: data['user'].firstname,
          lastname: data['user'].lastname,
          email: data['user'].email,
          gender: data['user'].gender,
          phone: data['user'].phone,
          taxDocumentNumber: data['user'].cpf
        });
      });

  }

  onSubmit(): void {

    this.form.patchValue({ email: localStorage.getItem('email') })

    if (!this.form.invalid) {
      const data = this.form.getRawValue();
      const params = new URLSearchParams();
      for (let key in data) {
        const value = data[key];
        //if (value)
        params.append(key, value);
      }

      localStorage.setItem('email', data.email);
      localStorage.setItem('password', data.password);
      const fullname = data.fullname+' '+data.lastname;
      localStorage.setItem('name', fullname)

      const bHref = this.pLocation.getBaseHrefFromDOM();
      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/step-company-contact?${params.toString()}`);
      setTimeout(() => this.submited.emit(), 3000);
      //this.submiting = true;

    }

  }

}
